var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
import Radio from 'syf-component-library/ui/atoms/Radio';
import { DATA_REASON, DATA_TYPE } from '../../../../const/analytics';
import { isMonthly } from '../../../../helpers';
import { t } from '../../../../strings/i18n';
const PaymentMethodSelectorOptionRadio = styled(Radio) `
  width: unset;
  label {
    margin: unset;
  }
`;
const PaymentMethodSelectorOption = (_a) => {
    var { type, isPaymentTypeError, handlePaymentMethodTypeChange, selected, featureFlags, productType } = _a, props = __rest(_a, ["type", "isPaymentTypeError", "handlePaymentMethodTypeChange", "selected", "featureFlags", "productType"]);
    const checkingLabel = isMonthly(productType) && !featureFlags.isSavingCheckingEnabled
        ? t('button.bankAccount')
        : t('button.checking');
    const PaymentMethodToOptionProps = {
        CHECKING: {
            id: 'checking-id',
            dataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CHECKING,
            errorDataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CHECKING_ERROR,
            label: checkingLabel,
            dataCy: 'checking'
        },
        SAVINGS: {
            id: 'savings-id',
            dataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_SAVINGS,
            errorDataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_SAVINGS_ERROR,
            label: t('button.savings'),
            dataCy: 'savings'
        },
        PINLESS_DEBIT_CARD: {
            id: 'debit-card-id',
            dataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_DEBIT,
            errorDataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_DEBIT_ERROR,
            label: t('button.debitCard'),
            dataCy: 'debit-card'
        },
        CREDIT_CARD: {
            id: 'credit-id',
            dataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CREDIT,
            errorDataReason: DATA_REASON.PAYMENT_METHOD.ADD_PAYMENT_METHOD_CREDIT_ERROR,
            label: t('button.creditCard'),
            dataCy: 'credit-card'
        }
    };
    const { id, dataReason, errorDataReason, label, dataCy } = PaymentMethodToOptionProps[type];
    return (_jsx(PaymentMethodSelectorOptionRadio, Object.assign({}, props, { checked: selected, dataAnalytics: "clicktrackingevent", dataCy: dataCy, dataReason: isPaymentTypeError ? errorDataReason : dataReason, dataType: DATA_TYPE.MAKE_A_PAYMENT, id: id, name: "paymentMethodType", value: type, onChange: () => handlePaymentMethodTypeChange(type) }, { children: label })));
};
export default PaymentMethodSelectorOption;
